import getBestLoyaltyRedemption from 'utils/get-best-loyalty-redemption';
import Slider from '../slider';
import './header.css';

export default (element, data) => {
  const createSlider = () => {
    const slider = new Slider({
      el: element.querySelector('[data-header-slider]'),
      options: {
        slidesPerView: 'auto',
      },
    });
    return slider;
  };

  const createInspirationSlider = () => {
    const slider = new Slider({
      el: element.querySelector('[data-header-inspiration-slider]'),
      options: {
        slidesPerView: 1.3,
        spaceBetween: 4,
      },
    });
    return slider;
  };

  const hamburgerMenu = () => {
    const hamburgerIcon = document.querySelector('.header__hamburger-icon');
    const menu = document.querySelector('.header__hamburger-menu');
    const overlay = document.querySelector('.overlay');
    const closeIcons = document.querySelectorAll('.header__close-icon');
    const allMobileMegaMenus = document.querySelectorAll(
      '[data-header-mega-menu]',
    );
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const hamburgerClasses = ['h-full', 'overflow-hidden'];

    hamburgerIcon.addEventListener('click', () => {
      if (menu.classList.contains('slide-out')) {
        menu.classList.remove('slide-out');
        menu.classList.add('slide-in');
        html.classList.add(...hamburgerClasses);
        body.classList.add(...hamburgerClasses);
      }
      overlay?.classList.remove('hidden');
      html.classList.add(...hamburgerClasses);
      body.classList.add(...hamburgerClasses);
    });

    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('overlay')) {
        menu.classList.remove('slide-in');
        menu.classList.add('slide-out');
        allMobileMegaMenus.forEach((sMenu) => {
          sMenu.classList.add('slide-out');
          setTimeout(() => {
            sMenu.classList.remove('slide-out');
            sMenu.classList.add('hidden');
          }, 200);
        });

        setTimeout(() => {
          overlay?.classList.add('hidden');
          html.classList.remove(...hamburgerClasses);
          body.classList.remove(...hamburgerClasses);
        }, '200');
      }
    });
    closeIcons.forEach((closeIcon) => {
      closeIcon.addEventListener('click', () => {
        menu.classList.remove('slide-in');
        menu.classList.add('slide-out');
        setTimeout(() => {
          overlay?.classList.add('hidden');
          html.classList.remove(...hamburgerClasses);
          body.classList.remove(...hamburgerClasses);
        }, '200');
        allMobileMegaMenus.forEach((sMenu) => {
          sMenu.classList.add('slide-out');
          setTimeout(() => {
            sMenu.classList.remove('slide-out');
            sMenu.classList.add('hidden');
          }, 200);
        });
      });
    });
    const allSliders = document.querySelectorAll('[data-header-mobile-slider]');
    allSliders.forEach((singleSlider) => {
      if (singleSlider.classList.contains('swiper')) {
        // eslint-disable-next-line
        const sliders = new Slider({
          el: singleSlider,
          options: {
            slidesPerView: 'auto',
            spaceBetween: 4,
          },
        });
        if (data.layout.isAboveBreakpoint('lg')) {
          const slides = singleSlider.querySelectorAll('.swiper-slide');
          slides.forEach((slide) => {
            slide.classList.remove('swiper-slide');
          });
          singleSlider.swiper.destroy();
        }
      }
    });
  };

  const hideAllMenus = () => {
    const megaMenus = element.querySelectorAll('[data-header-mega-menu]');
    const headerUnderlines = element.querySelectorAll(
      '[data-header-underline]',
    );
    megaMenus.forEach((megaMenu) => {
      megaMenu.classList.add('hidden');
    });
    headerUnderlines.forEach((item) => item.classList.add('hidden'));
  };

  const initMegaMenus = () => {
    const parentHeader = element.querySelector('[data-header]');
    const header = element.querySelector('[data-header-slider]');
    const links = header.querySelectorAll('[data-header-parent-link]');
    const megaMenus = element.querySelectorAll('[data-header-mega-menu]');
    let hasTouchEvent = false;
    const focusTrap = (menu, hoverElement, link) => {
      const focusableEls = menu.querySelectorAll(
        '.header__mega-menu-left a[href], .header__mega-menu-right a[href], button:not([disabled])',
      );
      const firstFocusableEl = focusableEls[0];
      const lastFocusableEl = focusableEls[focusableEls.length - 1];
      const nextLink = document.querySelector(
        `.header__menu-links [data-header-parent-link-index="${
          +link.dataset.headerParentLinkIndex + 1
        }"] a`,
      );
      const prevSectionLinks = document.querySelectorAll(
        '[data-header-links] a',
      );
      const prevLink =
        link.dataset.headerParentLinkIndex === '0'
          ? prevSectionLinks[prevSectionLinks.length - 1]
          : document.querySelector(
              `.header__menu-links [data-header-parent-link-index="${
                +link.dataset.headerParentLinkIndex - 1
              }"] a`,
            );

      firstFocusableEl.focus();

      menu.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' || e.keyCode === 9) {
          if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
              prevLink?.focus();
              e.preventDefault();
              menu.classList.add('hidden');
              parentHeader.classList.remove('menu-overlay');
              hoverElement.classList.add('hidden');
            }
          } else if (document.activeElement === lastFocusableEl) {
            nextLink?.focus();
            e.preventDefault();
            menu.classList.add('hidden');
            parentHeader.classList.remove('menu-overlay');
            hoverElement.classList.add('hidden');
          }
        }

        if (e.keyCode === 27) {
          e.preventDefault();
          menu.classList.add('hidden');
          parentHeader.classList.remove('menu-overlay');
          hoverElement.classList.add('hidden');
          nextLink?.focus();
        }
      });
    };
    const onMouseOver = (link, mouseLeaveEvent, hasFocusTrap = false) => {
      if (hasTouchEvent) {
        return;
      }
      hideAllMenus();
      const hoverElement = link.querySelector('[data-header-underline]');
      hoverElement.classList.remove('hidden');
      parentHeader.classList.remove('menu-overlay');
      megaMenus.forEach((menu) => {
        const linkParent = link.dataset.headerParentLinkTitle;
        const megaParent = menu.dataset.headerMegaMenuParentTitle;

        if (linkParent === megaParent) {
          menu.classList.remove('hidden');
          parentHeader.classList.add('menu-overlay');
          if (!link.dataset.eventsBound) {
            menu.addEventListener(mouseLeaveEvent, (e) => {
              e.stopPropagation();
              menu.classList.add('hidden');
              parentHeader.classList.remove('menu-overlay');
              hoverElement.classList.add('hidden');
            });

            link.addEventListener(mouseLeaveEvent, (event) => {
              const menuRect = menu.getBoundingClientRect();
              const mouseY = event.clientY;

              // Check if the mouse is within the menu element
              const isMouseWithinMenu = mouseY >= menuRect.top;

              if (!isMouseWithinMenu) {
                menu.classList.add('hidden');
                parentHeader.classList.remove('menu-overlay');
                hoverElement.classList.add('hidden');
              }
              if (
                event.relatedTarget.dataset.headerMegaMenuParentTitle !==
                linkParent
              ) {
                hasTouchEvent = false;
              }
            });
          }
          if (hasFocusTrap) focusTrap(menu, hoverElement, link);
        } else if (!link.dataset.eventsBound) {
          link.addEventListener(mouseLeaveEvent, (event) => {
            if (
              event.relatedTarget.dataset.headerMegaMenuParentTitle !==
              linkParent
            ) {
              hoverElement.classList.add('hidden');
              parentHeader.classList.remove('menu-overlay');
            }
          });
        }
      });
      // eslint-disable-next-line no-param-reassign
      link.dataset.eventsBound = true;
    };

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        hasTouchEvent = true;
        if (!data.layout.isAboveBreakpoint('lg')) return;
        e.stopPropagation();
        hideAllMenus();
        const hoverElement = link.querySelector('[data-header-underline]');
        hoverElement.classList.remove('hidden');
        parentHeader.classList.remove('menu-overlay');
        megaMenus.forEach((menu) => {
          const linkParent = link.dataset.headerParentLinkTitle;
          const megaParent = menu.dataset.headerMegaMenuParentTitle;
          if (linkParent === megaParent) {
            menu.classList.remove('hidden');
            parentHeader.classList.add('menu-overlay');
          }
        });
      });
      link.addEventListener('mouseover', () => {
        if (data.layout.isAboveBreakpoint('lg')) {
          onMouseOver(link, 'mouseleave');
        }
      });
      link.querySelector('a').addEventListener('focus', () => {
        if (data.layout.isAboveBreakpoint('lg')) {
          onMouseOver(link, 'blur', true);
        }
      });
    });

    megaMenus.forEach((menu) => {
      menu.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    document.querySelector('body').addEventListener('click', () => {
      if (
        data.layout.isAboveBreakpoint('xl') ||
        !data.layout.isAboveBreakpoint('lg')
      )
        return;
      parentHeader.classList.remove('menu-overlay');
      const hoverElements = header.querySelectorAll('[data-header-underline]');
      hoverElements.forEach((el) => el.classList.add('hidden'));
      hasTouchEvent = false;
      hideAllMenus();
    });
  };

  const initMobileMegaMenus = () => {
    const allMobileMegaMenus = document.querySelectorAll(
      '[data-header-mega-menu]',
    );
    const allLinks = document.querySelectorAll(
      '[data-header-links] [data-header-parent-link]',
    );
    const allTitles = document.querySelectorAll(
      '.header__hamburger-menu-single-title',
    );
    const promotionalBanner = document.querySelector(
      '[data-promotional-banner]',
    );
    allLinks.forEach((link) => {
      link.addEventListener('click', () => {
        const linkValue = link.getAttribute('data-header-parent-link-title');
        allMobileMegaMenus.forEach((megaMenu) => {
          const megaMenuValue = megaMenu.getAttribute(
            'data-header-mega-menu-parent-title',
          );
          if (linkValue === megaMenuValue && linkValue !== 'inspiration') {
            megaMenu.classList.remove('hidden');
            if (!promotionalBanner) {
              megaMenu.classList.add('top-0', 'h-[100vh]');
              megaMenu.classList.remove('top-[31px]', 'h-[calc(100vh_-_31px)]');
            }
          }
        });
      });
    });

    allTitles.forEach((title) => {
      title.addEventListener('click', () => {
        allMobileMegaMenus.forEach((singleMenu) => {
          singleMenu.classList.add('hidden');
        });
      });
    });
  };

  const initLoyaltyModal = () => {
    const classesToRemove = ['bg-gray-200', 'w-[50px]'];
    // eslint-disable-next-line no-undef
    function refreshCustomerDetails() {
      window.swellAPI.refreshCustomerDetails(async () => {
        const customerDetails = window.swellAPI.getCustomerDetails();
        const { nextRedemptionOption } = await getBestLoyaltyRedemption();

        const { pointsBalance } = customerDetails;
        const rewardWrapper = element.querySelectorAll('[data-reward]');
        if (rewardWrapper.length > 0) {
          const { unlockRewardModal } = window.TMW.Strings.customer;

          rewardWrapper.forEach((el) => {
            let newUnlockReward;
            if (!nextRedemptionOption) {
              newUnlockReward = `
                  <span>
                      ${window.TMW.Strings.customer.rewardsMaximumReached}
                  </span>
              `;
              // eslint-disable-next-line no-param-reassign
              el.innerHTML = newUnlockReward;
            } else {
              const needed = nextRedemptionOption.costInPoints - pointsBalance;
              newUnlockReward = unlockRewardModal.replace(
                '{XXX}',
                `<span class='font-medium'>${needed}</span>`,
              );
            }
            // eslint-disable-next-line no-param-reassign
            el.innerHTML = newUnlockReward;
          });
        }

        const pointsWrappers = element.querySelectorAll('[data-points]');
        pointsWrappers.forEach(
          // eslint-disable-next-line no-return-assign, no-param-reassign
          (points) => (points.innerHTML = `${pointsBalance} points`),
        );

        const tierWrappers = element.querySelectorAll('[data-tier]');

        tierWrappers.forEach(
          // eslint-disable-next-line no-return-assign, no-param-reassign
          (tier) => (tier.innerHTML = `${customerDetails.vipTier?.name}`),
        );

        const skeletonTargets = element.querySelectorAll(
          '[data-loyalty-skeleton]',
        );
        skeletonTargets.forEach((target) => {
          target.classList.remove(...classesToRemove);
        });

        const greetingElement = element.querySelectorAll('[data-greeting]');
        if (greetingElement) {
          const now = new Date();
          const hour = now.getHours();
          const {
            loyaltyGreetingMorning,
            firstName,
            loyaltyGreetingAfternoon,
          } = window.TMW.Strings.customer;

          let greetingMessage;
          if (hour < 12) {
            greetingMessage = `${loyaltyGreetingMorning} ${firstName}!`;
          } else {
            greetingMessage = `${loyaltyGreetingAfternoon} ${firstName}!`;
          }

          greetingElement?.forEach(
            // eslint-disable-next-line no-return-assign, no-param-reassign
            (item) => (item.innerHTML = greetingMessage),
          );
        }
      });
    }

    // Initial call
    refreshCustomerDetails();
  };

  const closeLoyaltyModal = () => {
    const closeBtns = element.querySelectorAll('[data-close-loyalty]');

    const modal = element.querySelector('.loyalty-modal.hidden');
    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        modal.classList.add('!hidden');
        setTimeout(() => {
          modal.classList.remove('!hidden');
        }, 100);
      });
    });
  };

  const init = () => {
    if (data.loggedIn) {
      if (
        window.swellAPI &&
        window.swellAPI.getCustomerDetails().email !== undefined
      ) {
        initLoyaltyModal();
      } else {
        // Poll for swellAPI and customer details if not immediately available
        const swellInterval = setInterval(() => {
          if (
            window.swellAPI &&
            window.swellAPI.getCustomerDetails &&
            window.swellAPI.getCustomerDetails().email !== undefined
          ) {
            clearInterval(swellInterval);
            initLoyaltyModal();
          }
        }, 200);
      }
    }

    const slider = createSlider();
    if (data.layout.isAboveBreakpoint('xl')) {
      slider.swiper.destroy();
    }

    initMegaMenus();
    initMobileMegaMenus();
    createInspirationSlider();
    hamburgerMenu();
    closeLoyaltyModal();
  };

  init();
};
